import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '@/components/common/Header';
import { Footer } from '@/components/common/Footer';
import { Hero } from '@/components/sections/Hero';
import { Services } from '@/components/sections/Services';
import { Features } from '@/components/sections/Features';
import { AutomationFeatures } from '@/components/sections/AutomationFeatures';
import { UseCases } from '@/components/sections/UseCases';
import { Integrations } from '@/components/sections/Integrations';
import { LLMIntegration } from '@/components/sections/LLMIntegration';
import { WhyChooseUs } from '@/components/sections/WhyChooseUs';
import { Team } from '@/components/sections/Team';
import { EarlyAccess } from '@/components/sections/EarlyAccess';
import { Capabilities } from '@/components/sections/Capabilities';
import { TargetAudience } from '@/components/sections/TargetAudience';
import { EnterpriseReadiness } from '@/components/sections/EnterpriseReadiness';
import { FAQ } from '@/components/sections/FAQ';
import { Contact } from '@/components/sections/Contact';
import { PartnerSection } from '@/components/sections/PartnerSection';
import { InvestorSection } from '@/components/sections/InvestorSection';
import { FloatingSupportButton } from '@/components/support/FloatingSupportButton';
import { FeatureComparison } from '@/components/sections/FeatureComparison';
// import { Pricing } from '@/components/sections/Pricing';
import {
  FEATURES,
  SERVICES,
  FAQS,
  TEAM_MEMBERS,
  CONTACT_INFO,
  NAV_ITEMS,
  SOCIAL_LINKS,
  EARLY_ACCESS,
  CAPABILITIES,
  TARGET_AUDIENCE,
  AUTOMATION_FEATURES,
  USE_CASES,
  INTEGRATIONS,
  ENTERPRISE_READINESS,
} from '@/lib/constants';
// PRICING_PLANS,

/**
 * HomePage Component
 * Main landing page that combines all sections
 */
export function HomePage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Handle anchor navigation when coming from other pages
  useEffect(() => {
    if (location.hash) {
      // Small delay to ensure the page has rendered
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Header */}
      <Header 
        isMenuOpen={isMobileMenuOpen}
        onMenuToggle={toggleMobileMenu}
      />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <Hero />

        {/* Services Section */}
        <Services services={SERVICES} />

        {/* Features Section */}
        <Features features={FEATURES} />

        {/* Automation Features Section */}
        {/* <AutomationFeatures data={AUTOMATION_FEATURES} /> */}

        {/* Use Cases Section */}
        <UseCases data={USE_CASES} />

        {/* Integrations Section */}
        <Integrations data={INTEGRATIONS} />

        {/* LLM Integration Section */}
        <LLMIntegration />

        {/* Why Choose Us Section */}
        <WhyChooseUs />

        {/* Capabilities Section */}
        <Capabilities data={CAPABILITIES} />

        {/* Enterprise Readiness Section */}
        <EnterpriseReadiness data={ENTERPRISE_READINESS} />

        {/* Team Section */}
        {/* <Team members={TEAM_MEMBERS} /> */}

        {/* Early Access Section */}
        <EarlyAccess data={EARLY_ACCESS} />

        {/* Target Audience Section */}
        <TargetAudience data={TARGET_AUDIENCE} />

        {/* Feature Comparison Section */}
        <FeatureComparison />

        {/* FAQ Section */}
        <FAQ faqs={FAQS} />

        {/* Contact Section */}
        <Contact contactInfo={CONTACT_INFO} />

        {/* Partner Section */}
        <PartnerSection />

        {/* Investor Section */}
        <InvestorSection />
      </main>

      {/* Footer */}
      <Footer
        navItems={NAV_ITEMS}
        socialLinks={SOCIAL_LINKS}
      />

      {/* Floating Support Button */}
      <FloatingSupportButton />
    </div>
  );
}
